<template>
  <MenuItemCollapse
    v-if="reports && reports.length"
    ref="menuReports"
    class="tender-reports"
    data-qa="reports"
    :flyout="growthBook.userPanelMenuFlyout"
    icon="docs"
    :icon-color="!reports || !reports.length ? 'grey' : 'var(--black-color)'"
    :label="$t('Common.Reports')"
    menu-item-class="h11-links pl-3">
    <div slot="submenu">
      <div
        v-for="report in reports"
        :key="report.id"
        class="report__item"
        @click.stop="createReport(report)">
        <sIcon
          class="report__item-icon"
          size="16"
          type="draft"/>
        <span
          class="report__item-label">{{ report.name }}</span>
      </div>
    </div>
  </MenuItemCollapse>
</template>
<script>
import MenuItemCollapse from 'components/common/MenuItemCollapse.vue'

import { findComponentsUpward, findComponentsDownward } from 'toolkit/utils/dom'

import { debounce } from 'toolkit/utils/util'
import SmarttenderApi from '@/api/smarttenderApi'
const api = new SmarttenderApi()

export default {
  name: 'tenderReports',
  data() {
    return {
      loading: true,
      show: false,
      reports: []
    }
  },
  methods: {
    isExistFile(key) {
      const defaultApp = findComponentsUpward(this, 'layout')
      if (!defaultApp?.length) {
        return false
      }
      const downloadFiles = findComponentsDownward(defaultApp[0], 'downloadFiles')
      if (!downloadFiles?.length) {
        return false
      }
      if (downloadFiles[0].files[key]) {
        return true
      }
      return false
    },
    createReport: debounce(async function (report) {
      this.$refs.menuReports.show = false
      const key = `report-${report.id}-${this.tender.tenderId}`

      if (this.isExistFile(key)) {
        this.$notice.info({
          title: report.name ?? report.title,
          message: this.$t('Tenders.fileAlreadyCreated'),
          duration: 10
        })
        return
      }
      report.title = `${report.name} #${this.tender.tenderNumber}`
      this.$notifier.generateReportFile(report, this.tender.tenderId, key)
      this.$refs.menuReports.show = false
      this.$emit('closeMenu')
      return
    }, 250),
  },
  components: {
    MenuItemCollapse
  },
  async created() {
    this.loading = true
    await api.getTenderReports(this.tender.tenderId)
      .then(res => {
        if ( res ) {
          this.reports = res
        }
      })
      .finally(() => {
        this.loading = false
      })

  },
  props: {
    tender: {
      type: Object,
      require: true
    }
  },
}
</script>
<style scoped lang="scss">
.tender-reports {
  --menu-flyout-top: -1px;
  --menu-flyout-gap: 5px;
  --menu-flyout-border: 1px solid var(--v-main__green-base);
  --menu-flyout-bg: var(--v-main__light_green-base);
}
%item {
  cursor: pointer;
  min-height: 40px;
  padding-right: 16px;
  padding-left: 16px;
  text-align: left;
  position: relative;
  display: flex;
  &:hover:not(.loading)::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0.3;
    background-color: var(--v-secondary__green_chosen-darken1);
  }
}
%item-label {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  margin: auto 0;
}
.report {
  &__btn {
    @extend %item;
    &-icon {
      margin: auto 16px auto 0;
    }
    &.loading {
      cursor: default;
      opacity: 0.5;
    }
    &-label {
      @extend %item-label;
    }
  }
}
::v-deep .report {
  &__items {
    border: 2px solid var(--color-main-green);
    border-radius: 5px;
    background: var(--v-main__light_green-base);
  }
  &__item {
    @extend %item;
    &-icon {
      margin: auto 16px auto 0;
    }
    &-label {
      @extend %item-label;
    }
  }
}
</style>
